import { useEffect, useRef, useState } from 'react';
import './Hero.css';
import './HeroVideo.css';
import RootCanvas from '../components/RootCanvas';
import useMagnetic from '../useMagnetic';
import { servicesData } from '../data/servicesData';

// Rotating identity words — cycles automatically to keep the hero feeling
// alive even before the visitor scrolls.
const ROTATING_WORDS = ['Growth Partners', 'ROI Strategists', 'Creative Thinkers', 'Performance Marketers', 'Academy Trainers'];

export default function Hero() {
  const [wordIndex, setWordIndex] = useState(0);
  const [videoReady, setVideoReady] = useState(false);
  const magPrimary = useMagnetic(0.3);
  const magSecondary = useMagnetic(0.3);
  const videoRef = useRef(null);

  // Cycle the rotating headline word every ~2.4s.
  useEffect(() => {
    const id = setInterval(() => {
      setWordIndex(i => (i + 1) % ROTATING_WORDS.length);
    }, 2400);
    return () => clearInterval(id);
  }, []);

  return (
    <>
    <section id="hero" className="hero hero-video-section">
      {/* Background video — drop a real clip at /public/videos/hero-bg.mp4
          (+ poster at /public/videos/hero-poster.jpg) and it takes over
          automatically. Until then, the root-growth canvas fills in so the
          hero never looks broken or empty. */}
      <div className="hero-video-bg">
        <RootCanvas className={`hero-canvas-fallback ${videoReady ? 'is-hidden' : ''}`} />
        <video
          ref={videoRef}
          className={`hero-bg-video ${videoReady ? 'is-ready' : ''}`}
          autoPlay
          muted
          loop
          playsInline
          poster="/videos/hero-poster.jpg"
          onCanPlay={() => setVideoReady(true)}
          onError={() => setVideoReady(false)}
        >
          <source src="/videos/hero-bg.mp4" type="video/mp4" />
        </video>
        <div className="hero-video-overlay" />
      </div>

      <div className="hero-grid">
        <div className="hero-content hero-video-content">
          <span className="hero-video-badge">
            <span className="badge-dot" />
            Digital Growth Agency in Trichy
          </span>

          <h1 className="hero-video-title">
            <span className="hero-video-title-static">We Are</span>
            <span className="hero-video-title-rotate" key={wordIndex}>
              {ROTATING_WORDS[wordIndex]}
            </span>
          </h1>

          <p className="hero-sub">
            AerialRoot connects your business to the digital world through AI-driven
            marketing, automation, and analytics — reaching deeper, growing faster.
          </p>

          <div className="hero-btns">
            <a
              href="#/contact"
              className="btn-primary"
              ref={magPrimary.ref}
              onMouseMove={magPrimary.onMouseMove}
              onMouseLeave={magPrimary.onMouseLeave}
            >
              Start Growing Today →
            </a>
            <a
              href="#/portfolio"
              className="btn-video-ghost"
              ref={magSecondary.ref}
              onMouseMove={magSecondary.onMouseMove}
              onMouseLeave={magSecondary.onMouseLeave}
            >
              View Our Work ↗
            </a>
          </div>

          <div className="hero-trust-strip">
            <span className="hero-trust-item">✓ Full site ownership, no lock-in</span>
            <span className="hero-trust-item">✓ Campaigns live in 48 hrs</span>
            <span className="hero-trust-item">✓ Weekly reports, real numbers</span>
          </div>
        </div>
      </div>
    </section>

    {/* Scrolling service names strip — sits below the hero, not inside it */}
    <section className="hero-marquee">
      <div className="hero-marquee-track">
        {[...Array(2)].map((_, r) => (
          <span className="hero-marquee-set" key={r}>
            {servicesData.map(s => (
              <span key={s.slug}>
                <span>{s.title}</span><span>•</span>
              </span>
            ))}
          </span>
        ))}
      </div>
    </section>
    </>
  );
}
